module.exports = __webpack_public_path__ + "static/img/qrCode.f6023dcf.jpg";